import React from 'react';

type IconProps = {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  children: React.ReactNode;
};

const Icon: React.FC<IconProps> = ({ onClick, children }) => {
  return (
    <div onClick={onClick} style={{ display: 'inline-block', cursor: 'pointer' }}>
      {children}
    </div>
  );
};

export default Icon;
